import Loadable from 'react/components/loadable';

const ProductDetailsModal = Loadable({
  loader: () => import('../../pages/pos/products/product_details'),
  type: 'modal',
});

angular.module('gym').value('ProductDetailsModal', ProductDetailsModal);
